import { useDispatch } from 'react-redux';
import type { RootDispatch, UpdateTemplatePayload } from '@/components/WellLoggingOperations/types';

type Options = {
    onSuccess?: () => void;
    onError?: () => void;
};

/*
    TODO: add isUpdating?
*/
export const useUpdateTemplate = () => {
    const dispatch = useDispatch<RootDispatch>();

    const updateTemplate = async (data: UpdateTemplatePayload, options: Options = {}) => {
        const { onSuccess, onError } = options;

        try {
            await dispatch.templates.updateTemplate(data);

            if (onSuccess) onSuccess();
        } catch (error) {
            if (onError) onError();
            // eslint-disable-next-line no-console
            console.error('error:update_template_request', error);
        }
    };

    return {
        updateTemplate,
    };
};
